const messages = [
    {
        "id": 1060001,
        "text": "You successfully recovered your account. Please change your password.",
        "type": "success",
        "context": {
            "privilegedSessionExpiresAt": "2020-01-01T01:01:00Z"
        }
    },
    {
        "id": 1060002,
        "text": "An email containing a recovery link has been sent to the email address you provided.",
        "type": "info",
        "context": {}
    },
    {
        "id": 1060003,
        "text": "An email containing a recovery code has been sent to the email address you provided.",
        "type": "info",
        "context": {}
    },
    {
        "id": 1080001,
        "text": "An email containing a verification link has been sent to the email address you provided.",
        "type": "info",
        "context": {}
    },
    {
        "id": 1080002,
        "text": "You successfully verified your email address.",
        "type": "success"
    },
    {
        "id": 1080003,
        "text": "An email containing a verification code has been sent to the email address you provided.",
        "type": "info",
        "context": {}
    },
    {
        "id": 4000006,
        "text": "The provided credentials are invalid.",
        "type": "error",
        "context": {}
    },
    {
        "id": 4000007,
        "text": "An account for this email already exists.",
        "type": "error",
        "context": {}
    },
    {
        "id": 4000008,
        "text": "The provided authentication code is invalid, please try again.",
        "type": "error",
        "context": {}
    },
    {
        "id": 4000010,
        "text": "Account not active yet. Did you forget to verify your email address?",
        "type": "error"
    }
]

const getMessage = (id, text) => {
    let message = text;
    for (let i=0;i<messages.length;i++) {
        if (messages[i].id === id){
            message = messages[i].text;
        }
    }
    return message;
}

export default {
    getMessage
}